//
//
//
//
//
//
//

export default{
  props: {
    refreshType: {
      type: Number,
      default: 1  // 0 更新用户信息 1 刷新主账户余额， 2 刷新游戏余额
    }
  },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {
    handleRefresh() {
      if (this.refreshType === 0) {
        this.$store.dispatch('refreshUserInfo')
      } else {
        this.$store.dispatch('refreshAccount', { type: this.refreshType, router: this.$router })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/refreshAcount/index.vue